import { defineComponent } from 'vue'
import './help-line.css'
import UEI from '../use/useEditInfo'

export const HelpLine = defineComponent({
  name: 'help-line',
  setup() {
    return () => {
      const xArr = UEI.state.lineObjInfo.x.filter(item => typeof item === 'number')
      const yArr = UEI.state.lineObjInfo.y.filter(item => typeof item === 'number')
      const xTarget = xArr.length ? xArr[0] : 'none'
      const yTarget = yArr.length ? yArr[0] : 'none'
      return (
        <div class="help-line">
          <>
            {typeof yTarget === 'number' ? <div class="help-line-item help-line-x" style={{ top: `${yTarget}px` }}></div> : null}
            {typeof xTarget === 'number' ? <div class="help-line-item help-line-y" style={{ left: `${xTarget}px` }}></div> : null}
          </>
        </div>
      )
    }
  }
})
